export const constants = {
  newMelodiesTagId: 471,
  popularMelodiesTagId: 352,

  mainPageSkippedTags: [349],

  mainPageMelodiesPageSize: {
    desktop: 12,
    other: 8
  },
  artistMelodiesPageSize: {
    desktop: 6,
    other: 4
  },
  melodyPageMelodiesPageSize: {
    desktop: 6,
    other: 4
  },
  genreMelodiesPageSize: {
    desktop: 21,
    tablet: 18,
    mobile: 8
  },
  searchMelodiesPageSize: {
    desktop: 6,
    other: 4
  },
  searchArtistsPageSize: {
    desktop: 6,
    other: 4
  },

  hitMelodiesId: 8,

  genresScrollWidth: 400,

  defaultImage: '/img/cover-default.png',
  gudokImage: '/img/cover-gudok.png',

  accessTokenCookieName: 'access',
  refreshTokenCookieName: 'refresh',
  desktopScreenBreakpoint: 1320,
  googlePlayLink: "https://play.google.com/store/apps/details?id=intech.global.com.beeline&hl=ru",
  appStoreLink: "https://apps.apple.com/ru/app/%D0%B7%D0%B0%D0%BC%D0%B5%D0%BD%D0%B8-%D0%B3%D1%83%D0%B4%D0%BE%D0%BA-%D0%BF%D1%80%D0%B8%D0%B2%D0%B5%D1%82-%D0%BE%D1%82-%D0%B1%D0%B8%D0%BB%D0%B0%D0%B9%D0%BD/id962279650",
  appGalleryLink: "https://appgallery.huawei.com/#/app/C101184959",
  autoRadioLink: "https://www.avtoradio.ru/money?utm_source=privetbeeline&utm_medium=banner&utm_campaign=mnogodeneg2024/?erid=2SDnje75sbf",

  titlePattern: { 'T': { pattern: /[a-zA-Zа-яА-Я0-9. \-]/} },
  searchPattern:{ 'T': { pattern: /^[a-zA-Zа-яА-Я0-9. \-!"#$%&'()*+,;:<=>?@[\]^_`{|}~№]*$/ } },
  blackListPattern: /[\/\\]/g,
  // searchPattern: {'T': {pattern: new RegExp("^[^?:/\\\\]*$")}},
  forbiddenChars: ['/','\\', ':', '?'],

  minUgcDuration: 10,
  maxUgcDuration: 45,

  encryptedMsisdn: 'encryptedMsisdn'
}
